import { useNavigate } from "react-router-dom";
import { InteractionStatus } from "@azure/msal-browser";
import { useMsal } from "@azure/msal-react";
import { Button, Loader, Space, Stack, Text, ThemeIcon } from "@mantine/core"
import { IconLock } from "@tabler/icons-react"

export const NoAccess = () => {
	const { instance, inProgress } = useMsal();
	const navigate = useNavigate();

	const handleLogout = () => {
		instance.logout({
			onRedirectNavigate: () => false
		});

		navigate('/');
	}

	return <Stack gap="xs" mt="xl" justify="center" align="center" style={{ height: '100%' }}>
		{inProgress != InteractionStatus.None && <Loader />}
		{inProgress == InteractionStatus.None && <>
			<ThemeIcon size={80} radius={80} color="gray" variant="light">
				<IconLock size={40} />
			</ThemeIcon>
			<Text fz="xl" fw="bold">
				No Access
			</Text>
			<Text fz="md" c="dimmed">
				You don't have access to this. Please contact your administrator if you believe this is an error.
			</Text>
			<Space h="lg" />
			<Button onClick={handleLogout} variant="filled" radius="xl">Sign Out</Button>
		</>}
	</Stack>
}